import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /** ... */
  color?: string;
  /** ... */
  blur?: string;
  /** Background color of the overlay. */
  // eslint-disable-next-line @typescript-eslint/ban-types
  background?: 'none' | (string & {});
  /** ... */
  fullscreen?: boolean;
  /** ... */
  transition?: string | number;
}

/** ... */

import { ref, computed, watch } from 'vue';
import type { StyleValue } from 'vue/types/jsx';
import uniqueId from 'lodash/uniqueId';

declare module 'vue/types/vue' {
  export interface Vue {
    Overlay: ComponentWithProps<Props>;
  }
}

// Disabled scrolling when at lease one fullscreen overlay is displayed.
//
// TODO: Determine whether not this is an OK practice -- using a non-setup
// scripts to track global values internally to a component.

const fullscreenOverlays = ref<string[]>([]);

watch(fullscreenOverlays, (ids) => {
  document.body.classList.toggle('fullscreen-overlay', ids.length > 0);
});

const __default__ = { name: 'Overlay' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: null,
    blur: null,
    background: null,
    fullscreen: { type: Boolean },
    transition: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  color?: string;
  /** ... */
  blur?: string;
  /** Background color of the overlay. */
  // eslint-disable-next-line @typescript-eslint/ban-types
  background?: 'none' | (string & {});
  /** ... */
  fullscreen?: boolean;
  /** ... */
  transition?: string | number;
};

/**
 * `Overlay` component properties.
 */
const uid = uniqueId();



/** ... */
const style = computed(() => {
  const style: StyleValue = {};

  if (props.color) {
    style.color = props.color;
  }

  if (props.blur) {
    style.backdropFilter = `blur(${props.blur})`;
  }

  if (props.background) {
    style.background =
      props.background === 'none' ? 'transparent' : props.background;
  }

  if (props.fullscreen) {
    style.position = 'fixed';
    style.inset = '0';
  }

  if (props.transition) {
    style.transition = `opacity ${props.transition}s`;
  }

  return style;
});

function onBeforeEnter() {
  if (props.fullscreen) {
    fullscreenOverlays.value = [...fullscreenOverlays.value, uid];
  }
}

function onBeforeLeave() {
  if (props.fullscreen) {
    fullscreenOverlays.value = fullscreenOverlays.value.filter(
      (id) => id !== uid,
    );
  }
}

return { __sfc: true,fullscreenOverlays, uid, props, style, onBeforeEnter, onBeforeLeave }
}

})